export const DAY_IN_MILLISECONDS = 86400000;

export const EVENT_COLORS = ['#3D979D', '#07967766', '#946ea299', '#5dbaee99', '#83e0d766'];
